// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk action import wizard — extends the .import-risks-wizard-* shell */

.action-import-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  background: #fff;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.action-import-trigger:hover {
  background: #f7fafa;
  border-color: #8a9ba7;
}

.action-import-paper {
  position: relative;
  max-width: min(1320px, calc(100vw - 48px)) !important;
  width: 100%;
  height: min(92vh, 980px);
  max-height: 92vh;
  overflow: hidden !important;
}

.MuiDialog-paperFullScreen.action-import-paper {
  max-width: 100% !important;
  height: 100%;
  max-height: 100%;
}

.action-import-stepper {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.action-import-body {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
}

.action-import-body .incyia-fsec {
  margin-bottom: 18px;
}

/* Mission and project summaries share a row, so the shorter card stretches to the taller one. */
.action-import-context .incyia-ffield > .qc-summary {
  flex: 1 1 auto;
}

/* ---------- Shared bits ---------- */

.action-import-field-error {
  display: block;
  margin-top: 5px;
  font-size: 14.5px;
  line-height: 1.35;
  font-weight: 600;
  color: #c0392b;
}

.action-import-hint {
  margin: 10px 0 0;
  font-size: 15px;
  line-height: 1.45;
  color: #5f7484;
}

.action-import-empty,
.action-import-placeholder {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 12px;
  border: 1px dashed #dfe7e8;
  border-radius: 8px;
  background: #f7fafa;
  color: #8a9ba7;
  font-size: 15.5px;
}

.action-import-empty {
  justify-content: center;
  min-height: 120px;
  margin-top: 18px;
}

.action-import-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}

.action-import-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  margin-left: 6px;
  padding: 0 8px;
  border-radius: 99px;
  border: 1px solid #dfe7e8;
  background: #f7fafa;
  font-size: 13.5px;
  font-weight: 700;
  color: #5f7484;
  white-space: nowrap;
}

.action-import-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid;
  font-size: 16px;
  line-height: 1.4;
}

.action-import-banner.is-warning {
  border-color: #f0d9a8;
  background: #fff8eb;
  color: #84540a;
}

.action-import-banner.is-success {
  border-color: #c5e4dc;
  background: #eef8f5;
  color: #076b5c;
  font-weight: 600;
}

.action-import-banner.is-busy {
  justify-content: flex-start;
  border-color: #c5e4dc;
  background: #eef8f5;
  color: #0f2d3a;
  font-weight: 600;
}

.action-import-banner.is-info {
  border-color: #cfdcf3;
  background: #f3f7fe;
  color: #1d3b72;
}

.action-import-banner.is-error {
  border-color: #f2c7c2;
  background: #fdf1ef;
  color: #9b2c20;
}

/* ---------- Source step ---------- */

.action-import-source-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.action-import-source-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border: 1.5px solid #dfe7e8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.action-import-source-card:hover {
  border-color: #b6d6cf;
}

.action-import-source-card:focus-visible {
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.25);
}

.action-import-source-card.is-selected {
  border-color: #0d9b87;
  background: #f4fbf9;
}

.action-import-source-check {
  position: absolute;
  top: 12px;
  right: 12px;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #0d9b87;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
}

.action-import-source-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2f7;
  color: #00146d;
  flex: none;
}

.action-import-source-icon svg {
  width: 20px;
  height: 20px;
}

.action-import-source-icon.is-csv { background: #e1f4f0; color: #076b5c; }
.action-import-source-icon.is-json { background: #fff4e0; color: #9a5b00; }
.action-import-source-icon.is-xml { background: #f0ebff; color: #5b3cc4; }
.action-import-source-icon.is-jira { background: #e6efff; color: #0c66e4; }

.action-import-source-name {
  margin-top: 4px;
  font-size: 17px;
  font-weight: 700;
  color: #0b1e2d;
}

.action-import-source-desc {
  font-size: 15px;
  line-height: 1.4;
  color: #5f7484;
}

.action-import-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 34px 20px;
  border: 2px dashed #c9d6d9;
  border-radius: 14px;
  background: #f7fafa;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
}

.action-import-drop.is-dragging {
  border-color: #0d9b87;
  background: #eef8f5;
}

.action-import-drop.has-error {
  border-color: #e3a49b;
}

.action-import-drop.has-file {
  padding: 18px 20px;
  border-style: solid;
  background: #fff;
}

.action-import-drop-icon {
  width: 34px;
  height: 34px;
  color: #0d9b87;
}

.action-import-drop-title {
  margin: 0;
  font-size: 17.5px;
  font-weight: 700;
  color: #0b1e2d;
}

.action-import-drop-hint {
  margin: 0 0 6px;
  font-size: 15px;
  color: #5f7484;
}

.action-import-file {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
}

.action-import-file-meta {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.action-import-file-meta b {
  font-size: 16.5px;
  color: #0b1e2d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-import-file-meta span {
  font-size: 14.5px;
  color: #8a9ba7;
}

.action-import-jira {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 20px;
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  background: #fff;
}

.action-import-jira h4 {
  margin: 0;
  font-size: 18px;
  color: #0b1e2d;
}

.action-import-jira p {
  margin: 0;
  font-size: 16px;
  line-height: 1.45;
  color: #5f7484;
}

.action-import-jira-points {
  margin: 0;
  padding-left: 18px;
  font-size: 15.5px;
  line-height: 1.6;
  color: #5f7484;
}

.action-import-jira .detail-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.action-import-jira.is-connected {
  border-color: #c5e4dc;
  background: #f4fbf9;
}

.action-import-jira-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 26px;
  padding: 0 10px;
  border-radius: 99px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 14.5px;
  font-weight: 800;
}

.action-import-jira-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, auto));
  gap: 8px 32px;
}

.action-import-jira-grid span {
  display: block;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.action-import-jira-grid b {
  font-size: 17px;
  color: #0b1e2d;
}

/* ---------- Review step ---------- */

.action-import-review {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.action-import-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.action-import-search {
  width: 260px !important;
  max-width: 100%;
}

.action-import-toolbar-spacer {
  flex: 1 1;
}

.action-import-segment {
  display: inline-flex;
  padding: 3px;
  border: 1px solid #dfe7e8;
  border-radius: 9px;
  background: #f7fafa;
}

.action-import-segment button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border: none;
  border-radius: 7px;
  background: none;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #5f7484;
  cursor: pointer;
}

.action-import-segment button.is-active {
  background: #fff;
  color: #0b1e2d;
  box-shadow: 0 1px 2px rgba(11, 30, 45, 0.12);
}

.action-import-segment button:focus-visible {
  outline: 2px solid #0d9b87;
  outline-offset: 1px;
}

.action-import-segment-count {
  min-width: 20px;
  padding: 0 6px;
  border-radius: 99px;
  background: #eef2f7;
  font-size: 13.5px;
  line-height: 18px;
}

.action-import-selection {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 4px 3px 12px;
  border-radius: 9px;
  background: #eef2fb;
  font-size: 15px;
  font-weight: 700;
  color: #00146d;
}

.action-import-grid {
  flex: 1 1;
  min-height: 360px;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.action-import-grid .MuiDataGrid-root {
  height: 100%;
}

.action-import-grid .is-error-row {
  background: #fffaf9;
}

.action-import-grid .is-jumped {
  box-shadow: inset 3px 0 0 #d97706;
}

.action-import-cell {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0b1e2d;
}

.action-import-cell.is-error {
  padding: 2px 6px;
  margin-left: -6px;
  border-radius: 6px;
  background: #fdecea;
  box-shadow: inset 0 0 0 1px #f2c7c2;
  color: #9b2c20;
  cursor: help;
}

.action-import-cell-empty {
  color: #a0aec0;
}

.action-import-line {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #5f7484;
}

.action-import-line.is-ok .action-import-dot { color: #0d9b87; }
.action-import-line.is-error .action-import-dot { color: #d14a3e; }

.action-import-row-actions {
  display: inline-flex;
  gap: 4px;
}

.action-import-icon-btn {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: none;
  color: #5f7484;
  cursor: pointer;
}

.action-import-icon-btn:hover,
.action-import-icon-btn:focus-visible {
  border-color: #dfe7e8;
  background: #f7fafa;
  color: #0b1e2d;
}

.action-import-icon-btn.is-danger:hover,
.action-import-icon-btn.is-danger:focus-visible {
  color: #c0392b;
}

/* ---------- Slide-over (row editor / bulk edit) ---------- */

.action-import-slideover-backdrop {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  justify-content: flex-end;
  background: rgba(6, 21, 36, 0.32);
  animation: action-import-fade 0.15s ease-out;
}

.action-import-slideover {
  display: flex;
  flex-direction: column;
  width: min(640px, 100%);
  height: 100%;
  background: #fff;
  box-shadow: -18px 0 40px -20px rgba(6, 21, 36, 0.45);
  animation: action-import-slide 0.2s ease-out;
}

.action-import-slideover-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px 12px;
  border-bottom: 1px solid #eef2f4;
}

.action-import-slideover-head h3 {
  margin: 0;
  font-size: 19px;
  color: #0b1e2d;
}

.action-import-slideover-head p {
  margin: 3px 0 0;
  font-size: 15px;
  color: #8a9ba7;
}

.action-import-slideover-body {
  flex: 1 1;
  overflow: auto;
  padding: 16px 22px;
}

.action-import-slideover-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 22px 16px;
  border-top: 1px solid #dfe7e8;
  background: #f7fafa;
}

.action-import-slideover-status {
  margin-right: auto;
  font-size: 15px;
  font-weight: 600;
  color: #5f7484;
}

@keyframes action-import-slide {
  from { transform: translateX(32px); opacity: 0; }
  to { transform: none; opacity: 1; }
}

@keyframes action-import-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ---------- Loading / error / result ---------- */

.action-import-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: auto;
  padding: 36px 24px;
  max-width: 560px;
  text-align: center;
}

.action-import-state h4 {
  margin: 4px 0 0;
  font-size: 19px;
  color: #0b1e2d;
}

.action-import-state p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #5f7484;
  word-break: break-word;
}

.action-import-state.is-error h4 { color: #9b2c20; }

.action-import-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  width: min(420px, 100%);
}

.action-import-progress > :first-child {
  flex: 1 1;
}

.action-import-progress span {
  font-size: 15px;
  font-weight: 700;
  color: #5f7484;
  font-variant-numeric: tabular-nums;
}

.action-import-result {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-import-result .action-import-state {
  margin: 0 auto;
}

.action-import-result-stats {
  display: flex;
  gap: 14px;
  margin: 6px 0;
}

.action-import-result-stats div {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 130px;
  padding: 14px 18px;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  background: #f7fafa;
}

.action-import-result-stats b {
  font-size: 32px;
  font-variant-numeric: tabular-nums;
  color: #0b1e2d;
}

.action-import-result-stats .is-ok b { color: #076b5c; }
.action-import-result-stats .is-error b { color: #c0392b; }

.action-import-result-stats span {
  font-size: 14.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.action-import-failures {
  margin: 0 auto;
  padding: 0;
  width: min(760px, 100%);
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.action-import-failures li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  border: 1px solid #f2c7c2;
  border-radius: 10px;
  background: #fdf6f5;
}

.action-import-failures b {
  font-size: 16px;
  color: #0b1e2d;
}

.action-import-failures span {
  font-size: 15px;
  color: #9b2c20;
}

/* ---------- Responsive ---------- */

@media (max-width: 900px) {
  .action-import-source-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .action-import-stepper.import-risks-wizard-stepper {
    grid-template-columns: repeat(4, auto);
    justify-content: space-between;
    margin: 0 16px 4px;
    padding: 6px 8px;
  }

  .action-import-stepper .import-risks-wizard-step-meta,
  .action-import-stepper .import-risks-wizard-step:not(.is-active) .import-risks-wizard-step-title {
    display: none;
  }

  .action-import-stepper .import-risks-wizard-step-title {
    white-space: nowrap;
  }

  .action-import-paper .incyia-modal-head p {
    display: none;
  }

  .action-import-body.import-risks-wizard-body {
    padding: 12px 16px 8px;
  }
}

@media (max-width: 560px) {
  .action-import-source-cards {
    grid-template-columns: 1fr;
  }

  .action-import-source-card {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 12px 14px;
  }

  .action-import-source-desc {
    flex-basis: 100%;
  }

  .action-import-search {
    width: 100% !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .action-import-slideover,
  .action-import-slideover-backdrop {
    animation: none;
  }
}

/* ---------- Larger type for the whole flow ---------- */

.action-import-paper .incyia-modal-head h3 { font-size: 21px; }
.action-import-paper .incyia-modal-head p { font-size: 15.5px; }

.action-import-paper .import-risks-wizard-step-index { width: 32px; height: 32px; font-size: 13.5px; }
.action-import-paper .import-risks-wizard-step-meta { font-size: 11.5px; }
.action-import-paper .import-risks-wizard-step-title { font-size: 15px; }

.action-import-paper .import-risks-wizard-foot-meta { font-size: 14.5px; }

.action-import-paper .incyia-fsec-head h4 { font-size: 17px; }
.action-import-paper .incyia-fsec-head p,
.action-import-paper .incyia-form-note { font-size: 15px; }
.action-import-paper .incyia-ffield-label { font-size: 14.5px; }
.action-import-paper .incyia-form-inp { font-size: 15.5px; }
.action-import-paper .incyia-ffield-help { font-size: 13.5px; }

.action-import-paper .detail-btn { font-size: 15px; }
.action-import-paper .detail-btn--sm { font-size: 14px; }

.action-import-paper [class*="-control"],
.action-import-paper [class*="-placeholder"],
.action-import-paper [class*="-singleValue"] {
  font-size: 15.5px !important;
}

.action-import-paper [class*="-multiValue"] > div {
  font-size: 13.5px !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/action/import/ImportActionsWizard.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gGAAgG;AAChG;EACE,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,qCAAqC,mBAAmB,EAAE,cAAc,EAAE;AAC1E,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,qCAAqC,mBAAmB,EAAE,cAAc,EAAE;;AAE1E;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA,+CAA+C,cAAc,EAAE;AAC/D,kDAAkD,cAAc,EAAE;;AAElE;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,8DAA8D;;AAE9D;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,eAAe,EAAE,UAAU,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,mCAAmC,cAAc,EAAE;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA,uCAAuC,cAAc,EAAE;AACvD,0CAA0C,cAAc,EAAE;;AAE1D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,yDAAyD;;AAEzD,6CAA6C,eAAe,EAAE;AAC9D,4CAA4C,iBAAiB,EAAE;;AAE/D,uDAAuD,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACrG,sDAAsD,iBAAiB,EAAE;AACzE,uDAAuD,eAAe,EAAE;;AAExE,sDAAsD,iBAAiB,EAAE;;AAEzE,4CAA4C,eAAe,EAAE;AAC7D;yCACyC,eAAe,EAAE;AAC1D,4CAA4C,iBAAiB,EAAE;AAC/D,wCAAwC,iBAAiB,EAAE;AAC3D,2CAA2C,iBAAiB,EAAE;;AAE9D,mCAAmC,eAAe,EAAE;AACpD,uCAAuC,eAAe,EAAE;;AAExD;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Bulk action import wizard — extends the .import-risks-wizard-* shell */\n\n.action-import-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  background: #fff;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.action-import-trigger:hover {\n  background: #f7fafa;\n  border-color: #8a9ba7;\n}\n\n.action-import-paper {\n  position: relative;\n  max-width: min(1320px, calc(100vw - 48px)) !important;\n  width: 100%;\n  height: min(92vh, 980px);\n  max-height: 92vh;\n  overflow: hidden !important;\n}\n\n.MuiDialog-paperFullScreen.action-import-paper {\n  max-width: 100% !important;\n  height: 100%;\n  max-height: 100%;\n}\n\n.action-import-stepper {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.action-import-body {\n  display: flex;\n  flex-direction: column;\n  padding-top: 16px;\n}\n\n.action-import-body .incyia-fsec {\n  margin-bottom: 18px;\n}\n\n/* Mission and project summaries share a row, so the shorter card stretches to the taller one. */\n.action-import-context .incyia-ffield > .qc-summary {\n  flex: 1 1 auto;\n}\n\n/* ---------- Shared bits ---------- */\n\n.action-import-field-error {\n  display: block;\n  margin-top: 5px;\n  font-size: 14.5px;\n  line-height: 1.35;\n  font-weight: 600;\n  color: #c0392b;\n}\n\n.action-import-hint {\n  margin: 10px 0 0;\n  font-size: 15px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.action-import-empty,\n.action-import-placeholder {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px dashed #dfe7e8;\n  border-radius: 8px;\n  background: #f7fafa;\n  color: #8a9ba7;\n  font-size: 15.5px;\n}\n\n.action-import-empty {\n  justify-content: center;\n  min-height: 120px;\n  margin-top: 18px;\n}\n\n.action-import-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: none;\n}\n\n.action-import-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  margin-left: 6px;\n  padding: 0 8px;\n  border-radius: 99px;\n  border: 1px solid #dfe7e8;\n  background: #f7fafa;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #5f7484;\n  white-space: nowrap;\n}\n\n.action-import-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.action-import-banner.is-warning {\n  border-color: #f0d9a8;\n  background: #fff8eb;\n  color: #84540a;\n}\n\n.action-import-banner.is-success {\n  border-color: #c5e4dc;\n  background: #eef8f5;\n  color: #076b5c;\n  font-weight: 600;\n}\n\n.action-import-banner.is-busy {\n  justify-content: flex-start;\n  border-color: #c5e4dc;\n  background: #eef8f5;\n  color: #0f2d3a;\n  font-weight: 600;\n}\n\n.action-import-banner.is-info {\n  border-color: #cfdcf3;\n  background: #f3f7fe;\n  color: #1d3b72;\n}\n\n.action-import-banner.is-error {\n  border-color: #f2c7c2;\n  background: #fdf1ef;\n  color: #9b2c20;\n}\n\n/* ---------- Source step ---------- */\n\n.action-import-source-cards {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.action-import-source-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 16px;\n  border: 1.5px solid #dfe7e8;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.action-import-source-card:hover {\n  border-color: #b6d6cf;\n}\n\n.action-import-source-card:focus-visible {\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.25);\n}\n\n.action-import-source-card.is-selected {\n  border-color: #0d9b87;\n  background: #f4fbf9;\n}\n\n.action-import-source-check {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #0d9b87;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.action-import-source-icon {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #eef2f7;\n  color: #00146d;\n  flex: none;\n}\n\n.action-import-source-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.action-import-source-icon.is-csv { background: #e1f4f0; color: #076b5c; }\n.action-import-source-icon.is-json { background: #fff4e0; color: #9a5b00; }\n.action-import-source-icon.is-xml { background: #f0ebff; color: #5b3cc4; }\n.action-import-source-icon.is-jira { background: #e6efff; color: #0c66e4; }\n\n.action-import-source-name {\n  margin-top: 4px;\n  font-size: 17px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.action-import-source-desc {\n  font-size: 15px;\n  line-height: 1.4;\n  color: #5f7484;\n}\n\n.action-import-drop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 34px 20px;\n  border: 2px dashed #c9d6d9;\n  border-radius: 14px;\n  background: #f7fafa;\n  text-align: center;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.action-import-drop.is-dragging {\n  border-color: #0d9b87;\n  background: #eef8f5;\n}\n\n.action-import-drop.has-error {\n  border-color: #e3a49b;\n}\n\n.action-import-drop.has-file {\n  padding: 18px 20px;\n  border-style: solid;\n  background: #fff;\n}\n\n.action-import-drop-icon {\n  width: 34px;\n  height: 34px;\n  color: #0d9b87;\n}\n\n.action-import-drop-title {\n  margin: 0;\n  font-size: 17.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.action-import-drop-hint {\n  margin: 0 0 6px;\n  font-size: 15px;\n  color: #5f7484;\n}\n\n.action-import-file {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n}\n\n.action-import-file-meta {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.action-import-file-meta b {\n  font-size: 16.5px;\n  color: #0b1e2d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.action-import-file-meta span {\n  font-size: 14.5px;\n  color: #8a9ba7;\n}\n\n.action-import-jira {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 20px;\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  background: #fff;\n}\n\n.action-import-jira h4 {\n  margin: 0;\n  font-size: 18px;\n  color: #0b1e2d;\n}\n\n.action-import-jira p {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.action-import-jira-points {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 15.5px;\n  line-height: 1.6;\n  color: #5f7484;\n}\n\n.action-import-jira .detail-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.action-import-jira.is-connected {\n  border-color: #c5e4dc;\n  background: #f4fbf9;\n}\n\n.action-import-jira-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 99px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 14.5px;\n  font-weight: 800;\n}\n\n.action-import-jira-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(160px, auto));\n  gap: 8px 32px;\n}\n\n.action-import-jira-grid span {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.action-import-jira-grid b {\n  font-size: 17px;\n  color: #0b1e2d;\n}\n\n/* ---------- Review step ---------- */\n\n.action-import-review {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.action-import-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.action-import-search {\n  width: 260px !important;\n  max-width: 100%;\n}\n\n.action-import-toolbar-spacer {\n  flex: 1;\n}\n\n.action-import-segment {\n  display: inline-flex;\n  padding: 3px;\n  border: 1px solid #dfe7e8;\n  border-radius: 9px;\n  background: #f7fafa;\n}\n\n.action-import-segment button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 7px;\n  background: none;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #5f7484;\n  cursor: pointer;\n}\n\n.action-import-segment button.is-active {\n  background: #fff;\n  color: #0b1e2d;\n  box-shadow: 0 1px 2px rgba(11, 30, 45, 0.12);\n}\n\n.action-import-segment button:focus-visible {\n  outline: 2px solid #0d9b87;\n  outline-offset: 1px;\n}\n\n.action-import-segment-count {\n  min-width: 20px;\n  padding: 0 6px;\n  border-radius: 99px;\n  background: #eef2f7;\n  font-size: 13.5px;\n  line-height: 18px;\n}\n\n.action-import-selection {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 4px 3px 12px;\n  border-radius: 9px;\n  background: #eef2fb;\n  font-size: 15px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.action-import-grid {\n  flex: 1;\n  min-height: 360px;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.action-import-grid .MuiDataGrid-root {\n  height: 100%;\n}\n\n.action-import-grid .is-error-row {\n  background: #fffaf9;\n}\n\n.action-import-grid .is-jumped {\n  box-shadow: inset 3px 0 0 #d97706;\n}\n\n.action-import-cell {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #0b1e2d;\n}\n\n.action-import-cell.is-error {\n  padding: 2px 6px;\n  margin-left: -6px;\n  border-radius: 6px;\n  background: #fdecea;\n  box-shadow: inset 0 0 0 1px #f2c7c2;\n  color: #9b2c20;\n  cursor: help;\n}\n\n.action-import-cell-empty {\n  color: #a0aec0;\n}\n\n.action-import-line {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 15px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #5f7484;\n}\n\n.action-import-line.is-ok .action-import-dot { color: #0d9b87; }\n.action-import-line.is-error .action-import-dot { color: #d14a3e; }\n\n.action-import-row-actions {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.action-import-icon-btn {\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  background: none;\n  color: #5f7484;\n  cursor: pointer;\n}\n\n.action-import-icon-btn:hover,\n.action-import-icon-btn:focus-visible {\n  border-color: #dfe7e8;\n  background: #f7fafa;\n  color: #0b1e2d;\n}\n\n.action-import-icon-btn.is-danger:hover,\n.action-import-icon-btn.is-danger:focus-visible {\n  color: #c0392b;\n}\n\n/* ---------- Slide-over (row editor / bulk edit) ---------- */\n\n.action-import-slideover-backdrop {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(6, 21, 36, 0.32);\n  animation: action-import-fade 0.15s ease-out;\n}\n\n.action-import-slideover {\n  display: flex;\n  flex-direction: column;\n  width: min(640px, 100%);\n  height: 100%;\n  background: #fff;\n  box-shadow: -18px 0 40px -20px rgba(6, 21, 36, 0.45);\n  animation: action-import-slide 0.2s ease-out;\n}\n\n.action-import-slideover-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px 12px;\n  border-bottom: 1px solid #eef2f4;\n}\n\n.action-import-slideover-head h3 {\n  margin: 0;\n  font-size: 19px;\n  color: #0b1e2d;\n}\n\n.action-import-slideover-head p {\n  margin: 3px 0 0;\n  font-size: 15px;\n  color: #8a9ba7;\n}\n\n.action-import-slideover-body {\n  flex: 1;\n  overflow: auto;\n  padding: 16px 22px;\n}\n\n.action-import-slideover-foot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 22px 16px;\n  border-top: 1px solid #dfe7e8;\n  background: #f7fafa;\n}\n\n.action-import-slideover-status {\n  margin-right: auto;\n  font-size: 15px;\n  font-weight: 600;\n  color: #5f7484;\n}\n\n@keyframes action-import-slide {\n  from { transform: translateX(32px); opacity: 0; }\n  to { transform: none; opacity: 1; }\n}\n\n@keyframes action-import-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* ---------- Loading / error / result ---------- */\n\n.action-import-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin: auto;\n  padding: 36px 24px;\n  max-width: 560px;\n  text-align: center;\n}\n\n.action-import-state h4 {\n  margin: 4px 0 0;\n  font-size: 19px;\n  color: #0b1e2d;\n}\n\n.action-import-state p {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #5f7484;\n  word-break: break-word;\n}\n\n.action-import-state.is-error h4 { color: #9b2c20; }\n\n.action-import-progress {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: min(420px, 100%);\n}\n\n.action-import-progress > :first-child {\n  flex: 1;\n}\n\n.action-import-progress span {\n  font-size: 15px;\n  font-weight: 700;\n  color: #5f7484;\n  font-variant-numeric: tabular-nums;\n}\n\n.action-import-result {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.action-import-result .action-import-state {\n  margin: 0 auto;\n}\n\n.action-import-result-stats {\n  display: flex;\n  gap: 14px;\n  margin: 6px 0;\n}\n\n.action-import-result-stats div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 130px;\n  padding: 14px 18px;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  background: #f7fafa;\n}\n\n.action-import-result-stats b {\n  font-size: 32px;\n  font-variant-numeric: tabular-nums;\n  color: #0b1e2d;\n}\n\n.action-import-result-stats .is-ok b { color: #076b5c; }\n.action-import-result-stats .is-error b { color: #c0392b; }\n\n.action-import-result-stats span {\n  font-size: 14.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.action-import-failures {\n  margin: 0 auto;\n  padding: 0;\n  width: min(760px, 100%);\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.action-import-failures li {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 14px;\n  border: 1px solid #f2c7c2;\n  border-radius: 10px;\n  background: #fdf6f5;\n}\n\n.action-import-failures b {\n  font-size: 16px;\n  color: #0b1e2d;\n}\n\n.action-import-failures span {\n  font-size: 15px;\n  color: #9b2c20;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 900px) {\n  .action-import-source-cards {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .action-import-stepper.import-risks-wizard-stepper {\n    grid-template-columns: repeat(4, auto);\n    justify-content: space-between;\n    margin: 0 16px 4px;\n    padding: 6px 8px;\n  }\n\n  .action-import-stepper .import-risks-wizard-step-meta,\n  .action-import-stepper .import-risks-wizard-step:not(.is-active) .import-risks-wizard-step-title {\n    display: none;\n  }\n\n  .action-import-stepper .import-risks-wizard-step-title {\n    white-space: nowrap;\n  }\n\n  .action-import-paper .incyia-modal-head p {\n    display: none;\n  }\n\n  .action-import-body.import-risks-wizard-body {\n    padding: 12px 16px 8px;\n  }\n}\n\n@media (max-width: 560px) {\n  .action-import-source-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .action-import-source-card {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 12px 14px;\n  }\n\n  .action-import-source-desc {\n    flex-basis: 100%;\n  }\n\n  .action-import-search {\n    width: 100% !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .action-import-slideover,\n  .action-import-slideover-backdrop {\n    animation: none;\n  }\n}\n\n/* ---------- Larger type for the whole flow ---------- */\n\n.action-import-paper .incyia-modal-head h3 { font-size: 21px; }\n.action-import-paper .incyia-modal-head p { font-size: 15.5px; }\n\n.action-import-paper .import-risks-wizard-step-index { width: 32px; height: 32px; font-size: 13.5px; }\n.action-import-paper .import-risks-wizard-step-meta { font-size: 11.5px; }\n.action-import-paper .import-risks-wizard-step-title { font-size: 15px; }\n\n.action-import-paper .import-risks-wizard-foot-meta { font-size: 14.5px; }\n\n.action-import-paper .incyia-fsec-head h4 { font-size: 17px; }\n.action-import-paper .incyia-fsec-head p,\n.action-import-paper .incyia-form-note { font-size: 15px; }\n.action-import-paper .incyia-ffield-label { font-size: 14.5px; }\n.action-import-paper .incyia-form-inp { font-size: 15.5px; }\n.action-import-paper .incyia-ffield-help { font-size: 13.5px; }\n\n.action-import-paper .detail-btn { font-size: 15px; }\n.action-import-paper .detail-btn--sm { font-size: 14px; }\n\n.action-import-paper [class*=\"-control\"],\n.action-import-paper [class*=\"-placeholder\"],\n.action-import-paper [class*=\"-singleValue\"] {\n  font-size: 15.5px !important;\n}\n\n.action-import-paper [class*=\"-multiValue\"] > div {\n  font-size: 13.5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
